// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NotificationTypes } from "./NotificationTypes";
import {
  NotificationTypesFromJSON,
  NotificationTypesFromJSONTyped,
  NotificationTypesToJSON,
  NotificationTypesToJSONTyped,
} from "./NotificationTypes";

/**
 *
 * @export
 * @interface SubscriptionsUpdate
 */
export interface SubscriptionsUpdate {
  /**
   *
   */
  notificationTypes: Array<NotificationTypes>;
}

/**
 * Check if a given object implements the SubscriptionsUpdate interface.
 */
export function instanceOfSubscriptionsUpdate(value: object): value is SubscriptionsUpdate {
  if (
    (!("notificationTypes" in (value as Record<string, any>)) &&
      !("notification_types" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["notificationTypes"] === undefined &&
      (value as Record<string, any>)["notification_types"] === undefined)
  )
    return false;
  return true;
}

export function SubscriptionsUpdateFromJSON(json: any): SubscriptionsUpdate {
  return SubscriptionsUpdateFromJSONTyped(json, false);
}

export function SubscriptionsUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SubscriptionsUpdate {
  if (json == null) {
    return json;
  }
  return {
    notificationTypes: (json["notification_types"] as Array<any>).map(NotificationTypesFromJSON),
  };
}

export function SubscriptionsUpdateToJSON(json: any): SubscriptionsUpdate {
  return SubscriptionsUpdateToJSONTyped(json, false);
}

export function SubscriptionsUpdateToJSONTyped(
  value?: SubscriptionsUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    notification_types: (value["notificationTypes"] as Array<any>).map(NotificationTypesToJSON),
  };
}
